import { graphql, useStaticQuery } from 'gatsby';

import { useFlatten } from './use-flatten';
import { getProperty } from 'utils';

export const useStaticPrivacy = () => {
	const results = useStaticQuery(query) || {};
	const key = 'squidex.findPrivacySingleton';

	return useFlatten(getProperty(results, key) || {});
};

const query = graphql`
	query usePrivacyQuery {
		squidex {
			findPrivacySingleton {
				id
				data {
					seo {
						de {
							title
							description
						}
					}

					header {
						de {
							title
						}
					}

					content {
						de {
							title
							text
						}
					}

					files {
						de {
							name
							file {
								localFile {
									publicURL
								}
								...SquidexLocalFileProps
							}
						}
					}

					items {
						de {
							title
							text
						}
					}
				}
			}
		}
	}
`;
